import { ControlledCheckbox } from "components/Card/ControlledInput";
import FutureMedicalCard from "components/Card/FutureMedicalCard";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

type CoverageFormValues = {
  coverage_complete: boolean;
  no_coverage: boolean;
};

type QueryInfoCardProps = {
  isCoverageComplete: boolean;
  isNoCoverage: boolean;
  onCoverageChange: (
    field: "coverage_complete" | "no_coverage",
    value: boolean,
  ) => Promise<void>;
  hasCoverage: boolean;
  hasCoverageValidationErrors: boolean;
};

export const QueryInfoCard = ({
  isCoverageComplete,
  isNoCoverage,
  onCoverageChange,
  hasCoverage,
  hasCoverageValidationErrors,
}: QueryInfoCardProps) => {
  const { control, setValue } = useForm<CoverageFormValues>({
    defaultValues: {
      coverage_complete: isCoverageComplete || false,
      no_coverage: isNoCoverage || false,
    },
  });

  // sync form values when props change
  useEffect(() => {
    setValue("coverage_complete", isCoverageComplete || false);
    setValue("no_coverage", isNoCoverage || false);
  }, [isCoverageComplete, isNoCoverage, setValue]);

  return (
    <div className="swim-column">
      <FutureMedicalCard heading="Query Information">
        <ControlledCheckbox
          control={control}
          name="coverage_complete"
          label="Coverage Complete"
          onSave={(value) => onCoverageChange("coverage_complete", value)}
          readOnly={hasCoverageValidationErrors}
          disabledReason={
            hasCoverageValidationErrors
              ? "Please resolve all validation errors on the Plan Coverage Information."
              : undefined
          }
        />
        <ControlledCheckbox
          control={control}
          name="no_coverage"
          label="No Coverage"
          onSave={(value) => onCoverageChange("no_coverage", value)}
          readOnly={hasCoverage}
          disabledReason={
            hasCoverage
              ? "Cannot mark as no coverage if coverage already exists."
              : undefined
          }
        />
      </FutureMedicalCard>
    </div>
  );
};
